/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description provider schema
 */

// schema keys
const providerFormFieldKeys = {
	name: {
		key: 'name',
		label: 'Name',
		errorMessage: 'Please enter the provider name.',
		placeholder: 'E.g.: John',
	},
	npi: {
		key: 'npi',
		label: 'NPI Number',
		errorMessage: 'Please enter the NPI number.',
		placeholder: 'E.g.: 1234567890',
	},
	ekycDetails: {
		key: 'ekycDetails',
		label: 'Identity Verification Status',
		tooltipMsg:
			'A Provider linked to the NPI will be available for Patient Eligibility or Claim status checks only after the Identity Verification process has been completed.',
	},
	status: {
		key: 'activeStatus',
		label: 'Status',
	},
	tin: {
		key: 'tin',
		label: 'TIN/EIN',
		tooltip:
			'Please enter the Taxpayer Identification Number (TIN) or Employer Identification Number (EIN) associated with the verifying Provider/Organization. This is required by us to initiate NPI enrollment with payers who require it to submit eligibility requests.',
		errorMessage: 'TIN/EIN is required to request enrollment with payers.',
		placeholder: 'E.g.: 1234567890',
	},
	resourceType: {
		key: 'resourceType',
		label: 'Resource Type',
	},
	humanName: {
		key: 'humanName',
		label: 'Name',
	},
};

export { providerFormFieldKeys };
